import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list__item-text" }
const _hoisted_2 = { class: "list__item-group-header" }
const _hoisted_3 = {
  key: 0,
  class: "list__item-group-subheader"
}
const _hoisted_4 = {
  key: 0,
  class: "list__item-icon"
}
const _hoisted_5 = ["src"]

import { toRefs } from 'vue'

interface EMITS {
  (e: 'longItemText', event: MouseEvent, header?: string, subheader?: string): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ListRow',
  props: {
  header: {
    type: String,
    required: true
  },
  subheader: {
    type: String,
    required: false,
    default: ''
  },
  icon: {
    type: Object,
    required: false,
    default: () => {}
  },
  imgSource: {
    type: String,
    required: false,
    default: ''
  },
  hasTooltip: {
    type: Boolean,
    default: false
  }
},
  emits: ["longItemText"],
  setup(__props, { emit: __emit }) {

const props = __props
const { header, subheader, icon, imgSource } = toRefs(props)
const emits = __emit
function onMouseEnter(e) {
  const headerEl = e.currentTarget.firstElementChild?.firstElementChild
  const subheaderEl = e.currentTarget.firstElementChild?.lastElementChild
  if (
    headerEl.clientWidth < headerEl.scrollWidth &&
    subheaderEl.clientHeight < subheaderEl.scrollHeight
  )
    emits('longItemText', e, header.value, subheader.value)
  else if (headerEl.clientWidth < headerEl.scrollWidth) {
    emits('longItemText', e, header.value)
  } else if (subheaderEl.clientHeight < subheaderEl.scrollHeight)
    emits('longItemText', e, subheader.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "list__item",
    onMouseenter: _cache[0] || (_cache[0] = (e) => (__props.hasTooltip ? onMouseEnter(e) : null))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(header)), 1),
      (_unref(subheader))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(subheader)), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(icon) || _unref(imgSource))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(icon))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon)), { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(imgSource))
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(imgSource)
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})